import React, { useEffect, useState } from 'react';
import './PageLoader.css';

interface PageLoaderProps {
    size?: 'small' | 'medium' | 'large';
    fullPage?: boolean;
    text?: string;
    delay?: number; // milliseconds before showing (prevents flash on fast loads)
}

const PageLoader: React.FC<PageLoaderProps> = ({
    size = 'medium',
    fullPage = false,
    text,
    delay = 200
}) => {
    const [show, setShow] = useState(delay === 0);

    useEffect(() => {
        if (delay > 0) {
            const timer = setTimeout(() => setShow(true), delay);
            return () => clearTimeout(timer);
        }
    }, [delay]);

    if (!show) return null;

    const loader = (
        <div
            className={`page-loader ${fullPage ? 'page-loader-fullpage' : ''}`}
            role="status"
            aria-live="polite"
            aria-label={text || 'Loading'}
        >
            <div className={`page-loader-spinner page-loader-${size}`}>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
            </div>
            {text && <p className="page-loader-text">{text}</p>}
        </div>
    );

    if (fullPage) {
        return (
            <div className="page-loader-overlay">
                {loader}
            </div>
        );
    }

    return loader;
};

export default PageLoader;
